export default __webpack_public_path__ + "static/media/login-brand-image-1-white.ba315255.jpg";